import { HTMLAttributes, ReactNode } from "react";

type ViewShellVariant = "start" | "choice" | "outcome";

type ViewShellProps = HTMLAttributes<HTMLElement> & {
  variant: ViewShellVariant;
  background?: ReactNode;
  children: ReactNode;
};

export function ViewShell({
  variant,
  background,
  children,
  className = "",
  ...rest
}: ViewShellProps) {
  const mergedClassName = ["view-shell", `view-shell--${variant}`, className]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    <section className={mergedClassName} {...rest}>
      {background}
      {children}
    </section>
  );
}
